import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, PageHeader, PasswordInput, useToast } from '../../../components/ui';
import { FormSection } from '../../../components/common/Parts/Parts';
import { useAuth } from '../../../app/providers/AuthProvider';
import { useForm } from '../../../hooks/useForm';
import { authService } from '../services/authService';
import type { FormEvent } from 'react';
import type { FormErrors } from '../../../hooks/useForm';

export default function ChangePassword() {
  const navigate = useNavigate();
  const toast = useToast();
  const { logout } = useAuth();
  const [saving, setSaving] = useState(false);
  const { form, set, errors, setErrors } = useForm({ currentPassword: '', newPassword: '', confirm: '' });

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    const errs: FormErrors = {};
    if (!form.currentPassword) errs.currentPassword = 'Enter your current password';
    if (form.newPassword.length < 8) errs.newPassword = 'At least 8 characters';
    if (form.confirm !== form.newPassword) errs.confirm = 'Passwords do not match';
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setSaving(true);
    try {
      await authService.changePassword({ currentPassword: form.currentPassword, newPassword: form.newPassword });
      toast.success('Password changed. Please log in again.');
      logout();
    } catch (err) {
      setErrors({ currentPassword: err.message });
      setSaving(false);
    }
  };

  return (
    <>
      <PageHeader title="Change password" />
      <form onSubmit={submit} noValidate className="max-w-2xl space-y-5">
        <FormSection title="Password" subtitle="You will be logged out on all devices">
          <PasswordInput label="Current password" value={form.currentPassword} onChange={set('currentPassword')} error={errors.currentPassword} containerClassName="sm:col-span-2" />
          <PasswordInput label="New password" autoComplete="new-password" value={form.newPassword} onChange={set('newPassword')} error={errors.newPassword} />
          <PasswordInput label="Repeat new password" autoComplete="new-password" value={form.confirm} onChange={set('confirm')} error={errors.confirm} />
        </FormSection>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => navigate(-1)} disabled={saving}>Cancel</Button>
          <Button type="submit" leftIcon="check" loading={saving}>Change password</Button>
        </div>
      </form>
    </>
  );
}
